import { observer } from 'mobx-react-lite'
import { useRcsContext } from 'pages/settings/pages/rcs/context/rcsContext'
import { RcsInfoForm } from './RcsInfoForm/RcsInfoForm'
import { RcsInfoHeader } from './RcsInfoHeader/RcsInfoHeader'

import styles from './styles.module.scss'

export const RcsInfo = observer(() => {
  const {} = useRcsContext()

  return (
    <section className={styles.container}>
      <RcsInfoHeader />
      <RcsInfoForm />
    </section>
  )
})
